class InfoSwitcher {
  constructor() {
    this.dom = {}
    this.dom.el = document.querySelector('.pdp-info-switch')
    this.dom.slides = document.querySelectorAll('.pdp-info-switcher_slide')
    this.dom.buttons = document.querySelectorAll('.pdp-info-switcher_tabber button')

    for (let i = 0; i < this.dom.buttons.length; i++) {
      const button = this.dom.buttons[i];

      button.addEventListener('click', () => {
        document.querySelector('.pdp-info-switcher_slide.is-active')?.classList.remove('is-active')
        document.querySelector('.pdp-info-switcher_tabber button.is-active')?.classList.remove('is-active')

        button.classList.add('is-active')
        this.dom.slides[i]?.classList.add('is-active')
      })
    }
  }
}

new InfoSwitcher()
